
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { BarChart } from 'lucide-react';
import { ResponsiveContainer, BarChart as ReBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';

interface RevenueBreakdownChartProps {
  revenueData: any[];
}

const RevenueBreakdownChart: React.FC<RevenueBreakdownChartProps> = ({ revenueData }) => {
  return (
    <Card className="bg-card/95 border-border/50">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2 text-white/95">
          <BarChart className="h-5 w-5 text-soundcharts-purple" />
          Revenue Breakdown
        </CardTitle>
        <CardDescription className="flex flex-wrap gap-2">
          <span className="text-white/70">Income sources and performance</span>
          <div className="flex gap-2 text-xs mt-1">
            <Badge variant="outline" className="border-soundcharts-purple/30 bg-black/20">
              <span className="h-2 w-2 rounded-full bg-soundcharts-purple mr-1"></span>
              <span className="text-white/90">Streaming</span>
            </Badge>
            <Badge variant="outline" className="border-soundcharts-purple/30 bg-black/20">
              <span className="h-2 w-2 rounded-full bg-soundcharts-darkPurple mr-1"></span>
              <span className="text-white/90">Sync/Licensing</span>
            </Badge>
            <Badge variant="outline" className="border-soundcharts-purple/30 bg-black/20">
              <span className="h-2 w-2 rounded-full bg-soundcharts-deepPurple mr-1"></span>
              <span className="text-white/90">Merchandise</span>
            </Badge>
          </div>
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px] w-full">
          <ResponsiveContainer width="100%" height="100%">
            <ReBarChart data={revenueData}>
              <CartesianGrid 
                strokeDasharray="3 3" 
                vertical={false} 
                stroke="rgba(255,255,255,0.1)" 
              />
              <XAxis 
                dataKey="name" 
                tick={{ fill: 'rgba(255,255,255,0.7)', fontSize: 12 }} 
                tickLine={false} 
                axisLine={{ stroke: 'rgba(255,255,255,0.1)' }} 
              />
              <YAxis 
                tick={{ fill: 'rgba(255,255,255,0.7)', fontSize: 12 }} 
                tickLine={false} 
                axisLine={{ stroke: 'rgba(255,255,255,0.1)' }} 
              />
              <Tooltip 
                contentStyle={{ 
                  backgroundColor: 'rgba(0,0,0,0.8)', 
                  borderColor: 'rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  color: 'rgba(255,255,255,0.9)'
                }} 
              />
              <Bar dataKey="streams" stackId="a" fill="#9b87f5" radius={[4, 4, 0, 0]} />
              <Bar dataKey="sync" stackId="a" fill="#7E69AB" radius={[4, 4, 0, 0]} />
              <Bar dataKey="merch" stackId="a" fill="#6E59A5" radius={[4, 4, 0, 0]} />
            </ReBarChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default RevenueBreakdownChart;
